import Component from '@cell/cell-core/component/component';
import './mega-menu.scss';

class MegaMenu extends Component {
  constructor() {
    super();

    this.activeDetailsElement = null;

    this.handleHeaderHover = this.handleHeaderHover.bind(this);
  }

  componentDidMount() {
    this.querySelectorAll('details > summary').forEach((summaryElement) =>
      summaryElement.addEventListener('mouseover', this.handleHover.bind(this)),
    );

    // Handle clicks outside mega menu dropdown.
    this.querySelector('.MegaMenu__Overlay').addEventListener('mouseover', () => {
      this.close(this.activeDetailsElement);
    });
  }

  handleHeaderHover(event) {
    // Close the menu if the user hovers over an element that is neither part of the mega menu
    // nor parent of it. This happens, for instance, if the user hovers over the cart action button.
    if (!this.contains(event.target) && !event.target.contains(this)) {
      this.close(this.activeDetailsElement);
    }
  }

  handleHover(event) {
    const hoveredDetailsElement = event.currentTarget.parentNode;

    if (hoveredDetailsElement.querySelector('summary + *')) {
      this.open(hoveredDetailsElement);
    } else if (this.activeDetailsElement) {
      // Close the active details element (which equals the last opened element) if a
      // mega menu item does not have a dropdown.
      this.close(this.activeDetailsElement);
    }
  }

  open(hoveredDetailsElement) {
    // The event listener should only be added the first time the mega menu is being opened.
    if (!this.activeDetailsElement) {
      this.closest('.section-header').addEventListener('mouseover', this.handleHeaderHover);
    }

    // Close all details elements but the clicked one to make sure that
    // only one can be open at a time.
    this.querySelectorAll('details').forEach((detailsElement) => {
      if (detailsElement !== hoveredDetailsElement) {
        detailsElement.removeAttribute('open');
        detailsElement.setAttribute('aria-expanded', 'false');
      }
    });

    hoveredDetailsElement.setAttribute('open', 'open');
    hoveredDetailsElement.setAttribute('aria-expanded', 'true');

    this.querySelector('.MegaMenu__Overlay').classList.add('MegaMenu__Overlay--Active');

    this.activeDetailsElement = hoveredDetailsElement;
  }

  close(hoveredDetailsElement) {
    hoveredDetailsElement.removeAttribute('open');
    hoveredDetailsElement.setAttribute('aria-expanded', 'false');

    this.querySelector('.MegaMenu__Overlay').classList.remove('MegaMenu__Overlay--Active');

    // Remove event listener since it's only needed if the mega menu is open.
    this.closest('.section-header').removeEventListener('mouseover', this.handleHeaderHover);

    this.activeDetailsElement = null;
  }
}

customElements.define('mega-menu', MegaMenu);
